import React, { useEffect, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import Footer from '../Components/Footer'
import '../Pages/Home.css'
import Navbar from '../Components/Navbar'
import Banner from '../Components/Banner'
import VAN1 from '../images/VAN1.jpg'
import VAN2 from '../images/VAN2.jpg'
import VAN3 from '../images/VAN3.jpg'
import VAN4 from '../images/VAN4.jpg'
import AOS from "aos";
import "aos/dist/aos.css";

import { Helmet } from "react-helmet";



export default function Home() {
    React.useEffect(() => {
    AOS.init({ duration: 800, once: false });
  }, []);
 const vans = [VAN1, VAN2, VAN3, VAN4];



const districts1 = [
    "Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem",
    "Tirunelveli", "Erode", "Thoothukudi", "Dindigul", "Theni",
    "Virudhunagar", "Aruppukottai", "Sivakasi", "Ramanathapuram", "Kanyakumari"
  ];

  const districts2 = [
    "Thanjavur", "Nagapattinam", "Tiruvarur", "Namakkal", "Karur",
    "Krishnagiri", "Dharmapuri", "Vellore", "Ranipet", "Tirupattur",
    "Kallakurichi", "Villupuram", "Cuddalore", "Perambalur", "Ariyalur"
  ];
















const testimonials = [
  { name: "Karthik (Aruppukottai)", text: "Travel service super ah irundhuchu. Time-ku pickup kuduthanga." },
  { name: "Praveen (Madurai)", text: "Driver polite and safe driving. Family trip ku perfect service." },
  { name: "Saranya (Virudhunagar)", text: "Long drive la comfortable ah travel pannom. Van neat ah irundhuchu." },
  { name: "Dinesh Kumar (Sivakasi)", text: "Service quality top notch. Price um reasonable." },
  { name: "Rajalakshmi (Aruppukottai)", text: "Ladies ku safety romba nalla service. Nambikka travel." },
  { name: "Gowtham (Tirunelveli)", text: "Driver route knowledge super. Time waste ah illa." },
  { name: "Meena (Salem)", text: "Office trip daily regular ah on-time service kudukranga." },
  { name: "Arunprasath (Kovilpatti)", text: "Vehicle clean and fresh. AC cooling super!" },
  { name: "Harish (Coimbatore)", text: "Wedding function ku booking pannom. Service semma smooth." },
  { name: "Sundar (Ramanathapuram)", text: "Driver behaviour decent and friendly." },
  { name: "Anitha (Trichy)", text: "Airport pickup super fast. No delay." },
  { name: "Bala (Chennai)", text: "Aruppukottai to Chennai travel smooth and safe." },
  { name: "Manoj (Erode)", text: "Car condition romba nalla irundhuchu. Highly recommended." },
  { name: "Vishnu (Thoothukudi)", text: "Long journey comfortable. Seats soft and clean." },
  { name: "Nivetha (Pudukottai)", text: "Ladies solo travel safe. Thank you for good service." },
];

const [current, setCurrent] = useState(0);

const nextTestimonial = () => {
  setCurrent((prev) => (prev + 1) % testimonials.length);
};

const prevTestimonial = () => {
  setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
};



const prev = () => {
  setCurrent((prevIndex) =>
    prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
  );
};

const next = () => {
  setCurrent((prevIndex) =>
    prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
  );
};















 const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqData = [
    {
      q: "What types of vehicles do you offer for rental?",
      a: "We provide Sedan, SUV, Innova, Van, Tourist Van, and Tempo Traveller for all types of trips."
    },
    {
      q: "Do you provide 24/7 travel service?",
      a: "Yes! SRI RAJALAKSHMI TRAVELS operates 24 hours every day, including Sundays."
    },
    {
      q: "Is one-way drop service available?",
      a: "Yes, we provide one-way taxi drop service anywhere in Tamil Nadu."
    },
    {
      q: "How can I book a vehicle?",
      a: "You can call, WhatsApp, or submit a booking request through our website."
    },
    {
      q: "Are your drivers experienced?",
      a: "All our drivers have 10+ years of driving experience with excellent route knowledge."
    },
    {
      q: "Do you offer outstation trips?",
      a: "Yes! Aruppukottai to all over Tamil Nadu, Kerala, Karnataka and Andhra Pradesh."
    },
    {
      q: "Is advance payment required?",
      a: "A small advance amount is needed to confirm your booking."
    },
    {
      q: "Do you offer airport pickup and drop?",
      a: "Yes, we provide pickup and drop services for Madurai, Trichy and Chennai airports."
    },
    {
      q: "Are vehicles clean and well-maintained?",
      a: "We maintain all vehicles neatly with regular service and AC-checkups."
    },
    {
      q: "Do you charge extra for night travel?",
      a: "No extra charges unless specified during special season demands."
    },
    {
      q: "Is luggage allowed in Sedan and SUV vehicles?",
      a: "Yes, all vehicles have adequate luggage space."
    },
    {
      q: "Do you provide rental for marriages and functions?",
      a: "Yes, we offer premium decorated vehicles for weddings and special events."
    },
    {
      q: "Can I get a driver-only service?",
      a: "Yes, driver-only service is available for local and outstation use."
    },
    {
      q: "Do you provide corporate office travel?",
      a: "Yes, daily office pickup and drop packages are available."
    },
    {
      q: "How much does a trip cost?",
      a: "Pricing depends on distance, vehicle type, and time. Our rates are completely transparent."
    },
    {
      q: "Can I book a vehicle for temple trips?",
      a: "Definitely! We provide special packages for Rameshwaram, Palani, Tirupati, Sabarimala and more."
    },
    {
      q: "How early should I book?",
      a: "For peak seasons, book 2–3 days earlier for guaranteed availability."
    },
    {
      q: "Is AC provided in all vehicles?",
      a: "Yes, every vehicle is fully air-conditioned and comfortable."
    },
    {
      q: "Are pets allowed inside the vehicle?",
      a: "Yes, pets are allowed only based on driver approval and customer responsibility."
    },
    {
      q: "Do you offer hourly rental?",
      a: "Yes, hourly packages are available for local city usage."
    }
  ];




  return (
    <>
<Helmet>
  {/* PAGE TITLE */}
  <title>Sri Rajalakshmi Travels | Van & Car Rental in Aruppukottai (24/7 Service)</title>

  {/* META DESCRIPTION */}
  <meta
    name="description"
    content="Book van rental, car rental, tour packages, airport pickup and family trip services in Aruppukottai. 24/7 Sri Rajalakshmi Travels with premium vans & experienced drivers."
  />

  {/* KEYWORDS */}
  <meta
    name="keywords"
    content="Aruppukottai travels, travels in Aruppukottai, van rental Aruppukottai, car rental Aruppukottai, force traveller booking, tempo traveller Aruppukottai, tour service Aruppukottai, airport pickup Aruppukottai"
  />

  {/* CANONICAL */}
  <link rel="canonical" href="https://srirajalakshmitravels.in/" />

  {/* OG TAGS */}
  <meta property="og:title" content="Sri Rajalakshmi Travels | Best Van & Car Rental in Aruppukottai" />
  <meta property="og:description" content="Premium vans, cars, tourist rides & 24/7 booking service in Aruppukottai." />
  <meta property="og:url" content="https://srirajalakshmitravels.in/" />
  <meta property="og:type" content="website" />

  {/* ========== SCHEMA #1 — TRAVEL AGENCY ========== */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "TravelAgency",
      name: "Sri Rajalakshmi Travels",
      url: "https://srirajalakshmitravels.in",
      image: "https://srirajalakshmitravels.com/static/media/SRILOGO.538e1e7c6643833d5ce3.png",
      telephone: "+91 90952 23243",
      address: {
        "@type": "PostalAddress",
        streetAddress: "12/4 Main Road",
        addressLocality: "Aruppukottai",
        addressRegion: "Tamil Nadu",
        postalCode: "626101",
        addressCountry: "IN",
      },
      openingHours: "Mo-Su 00:00-23:59",
      priceRange: "₹₹",
      sameAs: ["https://www.facebook.com/", "https://www.instagram.com/"],
    })}
  </script>

  {/* ========== SCHEMA #2 — SERVICE LIST ========== */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      serviceType: "Van Rental, Car Rental, Tourist Vehicle Booking",
      provider: {
        "@type": "TravelAgency",
        name: "Sri Rajalakshmi Travels",
      },
      areaServed: "Aruppukottai, Virudhunagar",
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Travel Services",
        itemListElement: [
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Van Rental in Aruppukottai" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Car Rental in Aruppukottai" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Tour Package Booking" } },
        ],
      },
    })}
  </script>

  {/* ========== SCHEMA #3 — REVIEW BOOST ========== */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Review",
      itemReviewed: {
        "@type": "LocalBusiness",
        name: "Sri Rajalakshmi Travels",
      },
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
      },
      author: {
        "@type": "Person",
        name: "Verified Customer",
      },
      reviewBody:
        "Excellent van rental service in Aruppukottai. Clean vehicles, friendly driver, on-time pickup!",
    })}
  </script>
</Helmet>



    <Navbar/>
    <Banner/>





 <section id="about-home" className="about-section">

      <div className="container">

        <h2 className="about-title" data-aos="fade-up">
          <span>SRI RAJALAKSHMI TRAVELS</span> – About Us
        </h2>

        {/* PARAGRAPHS */}
        <p className="about-para" data-aos="fade-up">
          <strong className="highlight">SRI RAJALAKSHMI TRAVELS</strong> has been a 
          <strong className="highlight"> trusted travel service </strong> 
          in Aruppukottai for 10+ years, serving customers with reliability and professionalism.
        </p>

        <p className="about-para" data-aos="fade-up">
          From South India to North India, we provide 
          <strong className="highlight"> safe, comfortable & professional </strong> 
          travel services trusted by thousands of passengers.
        </p>

        <p className="about-para" data-aos="fade-up">
          We offer premium and well-maintained vehicles for 
          <strong className="highlight"> family trips, temple tours, wedding functions, office travel, airport pick-up & drop </strong> 
          — ensuring a smooth and enjoyable journey.
        </p>

        <p className="about-para" data-aos="fade-up">
          All our drivers are 
          <strong className="highlight"> experienced, polite, and well-trained </strong>, 
          ensuring complete safety even during long-distance travel.
        </p>

        <p className="about-para" data-aos="fade-up">
          We follow strict punctuality, excellent route knowledge, and always give top priority to customer comfort.
        </p>

        <p className="about-para" data-aos="fade-up">
          Because of your trust, we have become one of the 
          <strong className="highlight"> top-rated travel services in Aruppukottai, Virudhunagar, Madurai, and Sivakasi. </strong>
        </p>

        <p className="about-para" data-aos="fade-up">
          Whether it is a local trip, outstation trip, one-way drop, round trip, or daily office commute — we provide 
          <strong className="highlight"> the best pricing with premium quality service. </strong>
        </p>

        <p className="about-para" data-aos="fade-up">
          Our fleet includes 
          <strong className="highlight"> Sedan, SUV, Innova, Van, and Tourist Vehicles </strong>, 
          all maintained in excellent condition for maximum comfort and safety.
        </p>

        <p className="about-para" data-aos="fade-up">
          Our core mission is to deliver 
          <strong className="highlight"> Safety, Comfort, Punctuality, and 100% Customer Satisfaction. </strong>
        </p>

        {/* FEATURES */}
        <div className="about-features" data-aos="fade-up">

          <div className="feature-box">
            <i className="feature-icon"><span>🚗</span></i>
            <p>10+ Years Experience</p>
          </div>

          <div className="feature-box">
            <i className="feature-icon"><span>🛣</span></i>
            <p>South–North India Coverage</p>
          </div>

          <div className="feature-box">
            <i className="feature-icon"><span>⭐</span></i>
            <p>Top Rated Service</p>
          </div>

          <div className="feature-box">
            <i className="feature-icon"><span>🕒</span></i>
            <p>On-Time Pickup</p>
          </div>

          <div className="feature-box">
            <i className="feature-icon"><span>💺</span></i>
            <p>Premium Vehicles</p>
          </div>

        </div>
      </div>

    </section>



<section id="VanGal" className="van-section">
  <div className="container">
    <h2 className="van-title" data-aos="fade-up">
      Our Premium <span>Van Collections</span>
    </h2>

    <div className="van-grid">
      {vans.map((img, index) => (
        <div className="van-card" key={index} data-aos="fade-up">
          <img src={img} alt={`Van ${index + 1}`} className="van-img" />

          {/* Hover Overlay */}
          <div className="van-overlay">
            <h4>Book This Van</h4>
            <a href="tel:+919999999999" className="van-btn">
              Call Now
            </a>
          </div>
        </div>
      ))}
    </div>

    {/* NEW BOOK US BUTTON */}
    <div className="book-us-wrapper" data-aos="fade-up">
      <a href="/services" className="book-us-btn">
        🚐 BOOK US NOW
      </a>
    </div>

  </div>
</section>


<section id="why-us" className="whyus-section">

  <div className="container">

    <h2 className="whyus-title" data-aos="fade-up">
      <span>Why Choose</span> SRI RAJALAKSHMI TRAVELS?
    </h2>

    <p className="whyus-subtext" data-aos="fade-up">
      Here are the top reasons why customers across Tamil Nadu trust our 24/7 travel service.
    </p>

    <div className="whyus-grid">

      <div className="whyus-card" data-aos="fade-up" data-aos-delay="100">
        <span className="whyus-icon">🛣</span>
        <h4>Experienced Drivers</h4>
        <p>Our drivers have 10+ years of experience with strong route knowledge.</p>
      </div>

      <div className="whyus-card" data-aos="fade-up" data-aos-delay="150">
        <span className="whyus-icon">🚗</span>
        <h4>Neat & Clean Vehicles</h4>
        <p>All vehicles are regularly serviced, clean, and fully air-conditioned.</p>
      </div>

      <div className="whyus-card" data-aos="fade-up" data-aos-delay="200">
        <span className="whyus-icon">💰</span>
        <h4>Transparent Pricing</h4>
        <p>No hidden charges — clear & customer-friendly pricing for all trips.</p>
      </div>

      <div className="whyus-card" data-aos="fade-up" data-aos-delay="250">
        <span className="whyus-icon">🕒</span>
        <h4>On-Time Pickup</h4>
        <p>Guaranteed punctual service for local, outstation, and airport trips.</p>
      </div>

      <div className="whyus-card" data-aos="fade-up" data-aos-delay="300">
        <span className="whyus-icon">📞</span>
        <h4>24/7 Customer Support</h4>
        <p>Call us anytime — we are available all day, all week for quick bookings.</p>
      </div>

      <div className="whyus-card" data-aos="fade-up" data-aos-delay="350">
        <span className="whyus-icon">🛡️</span>
        <h4>Safe for Family & Ladies</h4>
        <p>Our service is fully safe, secure, and trusted by families across TN.</p>
      </div>

    </div>

  </div>

</section>


  <section id="state-list" className="state-section">

      <div className="container">

        {/* TITLE */}
        <h2 className="state-title" data-aos="fade-up">
          <span>SRI RAJALAKSHMI TRAVELS</span> – Tamil Nadu Service Coverage
        </h2>

        <p className="state-subtext" data-aos="fade-up">
          We offer <strong className="highlight">Car Rental, Van Rental, Tourist Vehicles, Outstation Trips, One-way Drops</strong>  
          — From Aruppukottai to **Every District in Tamil Nadu**.
        </p>

        {/* TWO COLUMN LIST */}
        <div className="district-grid">

          <div className="district-column" data-aos="fade-up">
            <h3 className="district-heading">Major Cities</h3>
            <ul>
              {districts1.map((d, i) => (
                <li key={i}>
                  <span className="dot">🚗</span> {d}
                </li>
              ))}
            </ul>
          </div>

          <div className="district-column" data-aos="fade-up">
            <h3 className="district-heading">Other Districts</h3>
            <ul>
              {districts2.map((d, i) => (
                <li key={i}>
                  <span className="dot">🛣</span> {d}
                </li>
              ))}
            </ul>
          </div>

        </div>

      </div>

    </section>
















<section id="services" className="services-section">

  <div className="container">

    <h2 className="services-title" data-aos="fade-up">
      <span>Our Travel Services</span> – Complete Rental Solutions
    </h2>

    <p className="services-subtext" data-aos="fade-up">
      SRI RAJALAKSHMI TRAVELS provides premium <strong>Car Rental, Van Rental, Outstation Taxi, Airport Drop, Tourist Vehicle Services</strong> across Tamil Nadu.
      Fully safe, comfortable and available 24/7.
    </p>

    <div className="services-grid">

      <div className="service-box" data-aos="fade-up" data-aos-delay="100">
        <span className="service-icon">🚗</span>
        <h4>Car Rental Service</h4>
        <p>Clean & AC Sedan cars for local and outstation travel with affordable per-km pricing.</p>
      </div>

      <div className="service-box" data-aos="fade-up" data-aos-delay="150">
        <span className="service-icon">🚐</span>
        <h4>Van / Traveller Rental</h4>
        <p>Spacious Traveller Vans for family trips, tourist packages, wedding functions & more.</p>
      </div>

      <div className="service-box" data-aos="fade-up" data-aos-delay="200">
        <span className="service-icon">🛫</span>
        <h4>Airport Pickup & Drop</h4>
        <p>Madurai, Trichy & Chennai Airport drop services — on-time guarantee.</p>
      </div>

      <div className="service-box" data-aos="fade-up" data-aos-delay="250">
        <span className="service-icon">📍</span>
        <h4>One-Way Drop Taxi</h4>
        <p>Aruppukottai to all over Tamil Nadu one-way taxi with best rates.</p>
      </div>

      <div className="service-box" data-aos="fade-up" data-aos-delay="300">
        <span className="service-icon">🏛️</span>
        <h4>Temple Tour Packages</h4>
        <p>Rameshwaram, Palani, Kodaikanal, Tirupati, Sabarimala tour packages.</p>
      </div>

      <div className="service-box" data-aos="fade-up" data-aos-delay="350">
        <span className="service-icon">💼</span>
        <h4>Corporate Travel</h4>
        <p>Daily office pickup and drop packages for companies & employees.</p>
      </div>

    </div>

  </div>

</section>





<section id="routes" className="routes-section">

  <div className="container">

    <h2 className="routes-title" data-aos="fade-up">
      <span>Popular Routes</span> & Approx Pricing
    </h2>

    <p className="routes-subtext" data-aos="fade-up">
      SRI RAJALAKSHMI TRAVELS provides affordable Outstation Taxi, Car Rental & Van Rental 
      from Aruppukottai to all major Tamil Nadu cities.
    </p>

    <div className="routes-grid">

      <div className="route-box" data-aos="fade-up" data-aos-delay="100">
        <h4>🚗 Aruppukottai → Madurai</h4>
        <p>Starting from <strong>₹14 / km</strong></p>
      </div>

      <div className="route-box" data-aos="fade-up" data-aos-delay="150">
        <h4>🚗 Aruppukottai → Trichy</h4>
        <p>Starting from <strong>₹15 / km</strong></p>
      </div>

      <div className="route-box" data-aos="fade-up" data-aos-delay="200">
        <h4>🚗 Aruppukottai → Chennai</h4>
        <p>Starting from <strong>₹16 / km</strong></p>
      </div>

      <div className="route-box" data-aos="fade-up" data-aos-delay="250">
        <h4>🚗 Aruppukottai → Coimbatore</h4>
        <p>Starting from <strong>₹15 / km</strong></p>
      </div>

      <div className="route-box" data-aos="fade-up" data-aos-delay="300">
        <h4>🚗 Aruppukottai → Rameshwaram</h4>
        <p>Starting from <strong>₹14 / km</strong></p>
      </div>

      <div className="route-box" data-aos="fade-up" data-aos-delay="350">
        <h4>🚗 Aruppukottai → Kanyakumari</h4>
        <p>Starting from <strong>₹15 / km</strong></p>
      </div>

      <div className="route-box" data-aos="fade-up" data-aos-delay="400">
        <h4>🚗 Aruppukottai → Ooty</h4>
        <p>Starting from <strong>₹16 / km</strong></p>
      </div>

      <div className="route-box" data-aos="fade-up" data-aos-delay="450">
        <h4>🚗 Aruppukottai → Kodaikanal</h4>
        <p>Starting from <strong>₹15 / km</strong></p>
      </div>

    </div>

  </div>

</section>







<section id="open-hours" className="open-hours-section">

  <div className="container">

    <h2 className="open-title" data-aos="fade-up">
      <span>Opening Hours</span> – 24/7 Customer Support
    </h2>

    <p className="open-subtext" data-aos="fade-up" data-aos-delay="100">
      We are open all 7 days of the week. Call us anytime for bookings.
    </p>

    <div className="hours-grid">

      <div className="day-box" data-aos="fade-up" data-aos-delay="200">
        <h4>Monday</h4>
        <p>24 Hours</p>
      </div>

      <div className="day-box" data-aos="fade-up" data-aos-delay="250">
        <h4>Tuesday</h4>
        <p>24 Hours</p>
      </div>

      <div className="day-box" data-aos="fade-up" data-aos-delay="300">
        <h4>Wednesday</h4>
        <p>24 Hours</p>
      </div>

      <div className="day-box" data-aos="fade-up" data-aos-delay="350">
        <h4>Thursday</h4>
        <p>24 Hours</p>
      </div>

      <div className="day-box" data-aos="fade-up" data-aos-delay="400">
        <h4>Friday</h4>
        <p>24 Hours</p>
      </div>

      <div className="day-box" data-aos="fade-up" data-aos-delay="450">
        <h4>Saturday</h4>
        <p>24 Hours</p>
      </div>

      <div className="day-box" data-aos="fade-up" data-aos-delay="500">
        <h4>Sunday</h4>
        <p>24 Hours</p>
      </div>

    </div>

  </div>

</section>

<section className="testimonial-section">
  <h2 className="testimonial-title">Customer Testimonials</h2>

  <div className="testimonial-card" data-aos="fade-up">
    <div className="profile-icon">👤</div>

    <h3 className="testimonial-name">{testimonials[current].name}</h3>

    <p className="testimonial-text">
      {testimonials[current].text}
    </p>

    <div className="stars">★★★★★</div>
  </div>

  <div className="arrow-wrapper">
    <button className="arrow-btn" onClick={prev}>❮</button>
    <button className="arrow-btn" onClick={next}>❯</button>
  </div>
</section>












 <section id="faq" className="faq-section" data-aos="fade-up">
      <div className="container">

        <h2 className="faq-title">
          <span>Frequently Asked Questions</span>
        </h2>

        <div className="faq-container">
          {faqData.map((item, index) => (
            <div key={index} className="faq-item">
              <button className="faq-question" onClick={() => toggleFAQ(index)}>
                {item.q}
                {openIndex === index ? (
                  <FaChevronUp className="faq-icon" />
                ) : (
                  <FaChevronDown className="faq-icon" />
                )}
              </button>

              <div
                className={`faq-answer ${
                  openIndex === index ? "open" : ""
                }`}
              >
                <p>{item.a}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>







<section id="booking-process" className="booking-section">

  <div className="container">

    <h2 className="booking-title" data-aos="fade-up">
      <span>How to Book</span> Your Trip?
    </h2>

    <p className="booking-subtext" data-aos="fade-up">
      Fast & easy 4-step booking process for all cab / van rentals from Aruppukottai.
    </p>

    <div className="booking-grid">

      <div className="booking-card" data-aos="fade-up" data-aos-delay="100">
        <span className="booking-icon">📞</span>
        <h4>Step 1: Contact Us</h4>
        <p>Call or WhatsApp us anytime — 24/7 customer support available.</p>
      </div>

      <div className="booking-card" data-aos="fade-up" data-aos-delay="150">
        <span className="booking-icon">🚗</span>
        <h4>Step 2: Choose Your Vehicle</h4>
        <p>Select Sedan, SUV, Innova, Van, or Tourist Vehicle based on your trip.</p>
      </div>

      <div className="booking-card" data-aos="fade-up" data-aos-delay="200">
        <span className="booking-icon">📝</span>
        <h4>Step 3: Confirm Your Trip</h4>
        <p>Share your pickup location, date, time & travel plan.</p>
      </div>

      <div className="booking-card" data-aos="fade-up" data-aos-delay="250">
        <span className="booking-icon">🛣️</span>
        <h4>Step 4: Enjoy Your Journey</h4>
        <p>Driver arrives on time — safe, comfortable & smooth travel guaranteed.</p>
      </div>

    </div>

  </div>

</section>



<section id="nearby-trips" className="places-section">

  <div className="container">

    <h2 className="places-title" data-aos="fade-up">
      <span>Top Places</span> to Visit from Aruppukottai
    </h2>

    <p className="places-subtext" data-aos="fade-up">
      Popular tourist destinations and important travel routes we cover daily.
    </p>

    <div className="places-grid">

      <div className="place-card" data-aos="fade-up" data-aos-delay="100">
        <h4>Madurai</h4>
        <p>📍 Distance: 54 km</p>
        <p>🕒 Travel Time: 1 hr</p>
        <p>🚗 Best Vehicle: Sedan / SUV</p>
      </div>

      <div className="place-card" data-aos="fade-up" data-aos-delay="150">
        <h4>Rameshwaram</h4>
        <p>📍 Distance: 145 km</p>
        <p>🕒 Travel Time: 3 hrs</p>
        <p>🚐 Best Vehicle: SUV / Van</p>
      </div>

      <div className="place-card" data-aos="fade-up" data-aos-delay="200">
        <h4>Kanyakumari</h4>
        <p>📍 Distance: 235 km</p>
        <p>🕒 Travel Time: 4.5 hrs</p>
        <p>🚐 Best Vehicle: SUV / Traveller</p>
      </div>

      <div className="place-card" data-aos="fade-up" data-aos-delay="250">
        <h4>Tiruchirappalli</h4>
        <p>📍 Distance: 130 km</p>
        <p>🕒 Travel Time: 2.5 hrs</p>
        <p>🚗 Best Vehicle: Sedan</p>
      </div>

      <div className="place-card" data-aos="fade-up" data-aos-delay="300">
        <h4>Thoothukudi</h4>
        <p>📍 Distance: 108 km</p>
        <p>🕒 Travel Time: 2 hrs</p>
        <p>🚗 Best Vehicle: SUV</p>
      </div>

      <div className="place-card" data-aos="fade-up" data-aos-delay="350">
        <h4>Palani</h4>
        <p>📍 Distance: 160 km</p>
        <p>🕒 Travel Time: 3 hrs</p>
        <p>🚐 Best Vehicle: Van</p>
      </div>

      <div className="place-card" data-aos="fade-up" data-aos-delay="400">
        <h4>Sabarimala</h4>
        <p>📍 Distance: 265 km</p>
        <p>🕒 Travel Time: 6 hrs</p>
        <p>🚐 Best Vehicle: Traveller</p>
      </div>

      <div className="place-card" data-aos="fade-up" data-aos-delay="450">
        <h4>Kodaikanal</h4>
        <p>📍 Distance: 120 km</p>
        <p>🕒 Travel Time: 3 hrs</p>
        <p>🚗 Best Vehicle: Sedan / SUV</p>
      </div>

      <div className="place-card" data-aos="fade-up" data-aos-delay="500">
        <h4>Tirupati</h4>
        <p>📍 Distance: 430 km</p>
        <p>🕒 Travel Time: 7 hrs</p>
        <p>🚐 Best Vehicle: Innova / Traveller</p>
      </div>

    </div>

  </div>

</section>



<section id="TOC" className="toc-section" data-aos="fade-up">

  <div className="container">

    <h2 className="toc-title">
      <span>Table of Contents</span>
    </h2>

    <p className="toc-subtext">Quick navigation to all sections of SRI RAJALAKSHMI TRAVELS</p>

    <div className="toc-grid">

      <a href="#about-home" className="toc-box" data-aos="fade-up" data-aos-delay="100">
        <span className="toc-icon">📘</span>
        <h4>About Us</h4>
      </a>

      <a href="#VanGal" className="toc-box" data-aos="fade-up" data-aos-delay="150">
        <span className="toc-icon">🚌</span>
        <h4>Van Collections</h4>
      </a>

      <a href="#state-list" className="toc-box" data-aos="fade-up" data-aos-delay="200">
        <span className="toc-icon">🗺️</span>
        <h4>Service Coverage</h4>
      </a>

      <a href="#open-hours" className="toc-box" data-aos="fade-up" data-aos-delay="250">
        <span className="toc-icon">⏰</span>
        <h4>Opening Hours</h4>
      </a>

      <a href="#testimonials" className="toc-box" data-aos="fade-up" data-aos-delay="300">
        <span className="toc-icon">⭐</span>
        <h4>Testimonials</h4>
      </a>

      <a href="#faq" className="toc-box" data-aos="fade-up" data-aos-delay="350">
        <span className="toc-icon">❓</span>
        <h4>FAQ</h4>
      </a>

    </div>

  </div>

</section>

<Footer/>

    </>
  )
}
